module.exports = {"searchResponse.warning":"Žiaden subjekt sme pod týmto výrazom nenašli.","searchResponse.error":"Chyba pri vyhľadávaní subjektov."}